module.exports = __webpack_public_path__ + "SLK.e11d814a.atlas";